import { createApp } from "vue";
import RecordingCropApp from "./RecordingCropApp.vue";
import { i18n } from '../../i18n';

if (document.querySelector('#recording_crop_app')) {
  const app = createApp(RecordingCropApp)
  app.use(i18n);
  app.mount('#recording_crop_app');
}
